import { DocumentSelectOption, Kunde, SelectOption } from '@gsm/entities';
import { DYNAMIC_FORM_CONTROL_TYPE_CHECKBOX, DYNAMIC_FORM_CONTROL_TYPE_INPUT, DYNAMIC_FORM_CONTROL_TYPE_SELECT } from '@ng-dynamic-forms/core';
import { createOptionsFromEntities } from '../../helpers/options.helper';
import { TYPE_ACTION_BUTTON } from '../action-button/action-button.model';
import { TYPE_CHIP_CHOICE_AUTOCOMPLETE } from '../chip-choice-autocomplete/chip-choice-autocomplete.model';
import { TYPE_CUSTOM_FILE_UPLOAD } from '../custom-file-upload/custom-file-upload.model';
import { TYPE_INFO } from '../info/info.model';
import { AnyFormControlModel } from '../shared-models/any-form-control.model';
import { TYPE_ZAHLUNGSEMPFAENGER } from '../zahlungsempfaenger/zahlungsempfaenger.model';
import { DokumentenAngabeAdditional } from './dokumenten-angabe.model';

// return template required document group
export function DOKUMENTEN_REQUIRED_TEMPLATE_FACTORY({
                                                       requiredTypes = [],
                                                       acceptedFileTypes = [],
                                                       gewerke = [],
                                                       kunden = [],
                                                       immediateValidation = false
                                                     }: DokumentenAngabeAdditional): AnyFormControlModel[] {
  return [
    {
      id:         'required',
      type:       DYNAMIC_FORM_CONTROL_TYPE_CHECKBOX,
      hidden:     true,
      additional: {
        forceLog: true
      },
      value:      true
    },
    {
      id:         'id',
      type:       DYNAMIC_FORM_CONTROL_TYPE_INPUT,
      hidden:     true,
      additional: {
        forceLog: true
      }
    },
    {
      id:            'typ',
      type:          DYNAMIC_FORM_CONTROL_TYPE_SELECT,
      required:      true,
      placeholder:   'Dokumenttyp',
      optionMatcher: ['value'],
      options:       createOptionsFromEntities(requiredTypes, 'label'),
      disabled:      true
    },
    {
      id:            'bezeichnung',
      type:          DYNAMIC_FORM_CONTROL_TYPE_INPUT,
      label:         'Bezeichnung',
      placeholder:   'Bezeichnung hinzufügen',
      disabled:      true,
      hidden:        true,
      validators:    {
        maxLength: 300
      },
      errorMessages: {
        maxLength: 'Bitte geben Sie maximal 300 Zeichen ein.'
      }
    },
    {
      id:            'geschaedigtePerson',
      type:          DYNAMIC_FORM_CONTROL_TYPE_SELECT,
      label:         'Geschädigte Person',
      disabled:      true,
      hidden:        true,
      optionMatcher: ['kundeId']
    },
    {
      id:          'vorhanden',
      type:        DYNAMIC_FORM_CONTROL_TYPE_SELECT,
      required:    true,
      placeholder: 'Vorhanden?',
      options:     [
        {
          label: 'Vorhanden',
          value: 'V'
        },
        {
          label: 'Wird nachgebracht',
          value: 'N'
        },
        {
          label: 'Nicht vorhanden',
          value: 'NV'
        }
      ],
      value:       'V'
    },
    {
      id:            'grund',
      type:          DYNAMIC_FORM_CONTROL_TYPE_INPUT,
      label:         'Begründung',
      name:          'grund',
      placeholder:   'Begründung eingeben',
      validators:    {
        maxLength: 500
      },
      errorMessages: {
        maxLength: 'Bitte geben Sie maximal 500 Zeichen ein.'
      },
      required:      true,
      relations:     [
        {
          match: 'VISIBLE',
          when:  [
            {
              id:    'vorhanden',
              value: 'NV'
            }
          ]
        }
      ]
    },
    {
      id:           'checklistItemFileList',
      type:         TYPE_CUSTOM_FILE_UPLOAD,
      labelTooltip: 'Dateien hinzufügen...',
      required:     true,
      accept:       acceptedFileTypes,
      showDropzone: true,
      layout:       {
        element: {
          host: 'gsm-flex-fullwidth'
        }
      },
      relations:    [
        {
          match: 'VISIBLE',
          when:  [
            {
              id:    'vorhanden',
              value: 'V'
            }
          ]
        }
      ]
    },
    ...gewerkeTemplateFactory(gewerke, requiredTypes),
    ...zahlungsEmpfaengerTemplateFactory(kunden, immediateValidation, requiredTypes)
  ];
}

// return template optional document group
export function DOKUMENTEN_OPTIONAL_TEMPLATE_FACTORY({
                                                       optionalTypes = [],
                                                       acceptedFileTypes = [],
                                                       gewerke = [],
                                                       kunden = [],
                                                       immediateValidation = false
                                                     }: DokumentenAngabeAdditional): AnyFormControlModel[] {
  return [
    {
      id:         'required',
      type:       DYNAMIC_FORM_CONTROL_TYPE_CHECKBOX,
      hidden:     true,
      additional: {
        forceLog: true
      },
      value:      false
    },
    {
      id:         'id',
      type:       DYNAMIC_FORM_CONTROL_TYPE_INPUT,
      hidden:     true,
      additional: {
        forceLog: true
      }
    },
    {
      id:            'typ',
      type:          DYNAMIC_FORM_CONTROL_TYPE_SELECT,
      required:      true,
      placeholder:   'Dokumenttyp',
      optionMatcher: ['value'],
      options:       createOptionsFromEntities(optionalTypes, 'label'),
      value:         null
    },
    {
      id:            'bezeichnung',
      type:          DYNAMIC_FORM_CONTROL_TYPE_INPUT,
      label:         'Bezeichnung',
      placeholder:   'Bezeichnung hinzufügen',
      validators:    {
        maxLength: 300
      },
      errorMessages: {
        maxLength: 'Bitte geben Sie maximal 300 Zeichen ein.'
      }
    },
    {
      id:            'geschaedigtePerson',
      type:          DYNAMIC_FORM_CONTROL_TYPE_SELECT,
      label:         'Geschädigte Person',
      disabled:      true,
      hidden:        true,
      optionMatcher: ['kundeId']
    },
    {
      id:          'vorhanden',
      type:        DYNAMIC_FORM_CONTROL_TYPE_SELECT,
      required:    true,
      placeholder: 'Vorhanden?',
      options:     [
        {
          label: 'Vorhanden',
          value: 'V'
        },
        {
          label: 'Wird nachgebracht',
          value: 'N'
        }
      ],
      value:       'V'
    },
    {
      id:                 'delete',
      type:               TYPE_ACTION_BUTTON,
      labelTooltip:       'Löschen',
      icon:               'delete',
      eventName:          'delete',
      hiddenWhenDisabled: true,
      layout:             {
        element: {
          host: 'gsm-no-flex-grow'
        }
      }
    },
    {
      id:           'checklistItemFileList',
      type:         TYPE_CUSTOM_FILE_UPLOAD,
      labelTooltip: 'Dateien hinzufügen...',
      required:     true,
      accept:       acceptedFileTypes,
      showDropzone: true,
      layout:       {
        element: {
          host: 'gsm-flex-fullwidth'
        }
      },
      relations:    [
        {
          match: 'VISIBLE',
          when:  [
            {
              id:    'vorhanden',
              value: 'V'
            }
          ]
        },
        {
          match: 'OPTIONAL',
          when:  [
            {
              id:    'typ',
              value: {
                label: 'Sonstige Zahlung',
                value: 'SONST_ZAHL'
              }
            }
          ]
        }
      ]
    },
    ...gewerkeTemplateFactory(gewerke, optionalTypes),
    ...zahlungsEmpfaengerTemplateFactory(kunden, immediateValidation, optionalTypes)
  ];
}

function gewerkeTemplateFactory(gewerke: SelectOption[], documentTypes: DocumentSelectOption[]): AnyFormControlModel[] {
  const relations = [
    {
      match: 'SELECT_VISIBLE',
      when:  documentTypes
               .filter(type => type.gewerkeRequired)
               .map(type => ({
                 id:    'typ',
                 value: type
               }))
    }
  ];
  const layout = {
    element: {
      host: 'gsm-flex-fullwidth'
    }
  };

  return [
    {
      id:            'gewerke_instructionText',
      type:          TYPE_INFO,
      content:       'Bitte geben Sie die Gewerke bekannt.',
      isInstruction: true,
      hidden:        true,
      optionMatcher: ['value'],
      relations,
      layout,
      additional:    {
        hideLog: true
      }
    },
    {
      id:            'gewerke',
      type:          TYPE_CHIP_CHOICE_AUTOCOMPLETE,
      label:         'Gewerke',
      placeholder:   'Gewerke auswählen',
      required:      true,
      hidden:        true,
      options:       createOptionsFromEntities(gewerke, 'label'),
      optionMatcher: ['value'],
      relations,
      layout
    }
  ];
}

function zahlungsEmpfaengerTemplateFactory(
  kunden: Kunde[],
  immediateValidation: boolean,
  documentTypes: DocumentSelectOption[]
): AnyFormControlModel[] {
  const relations = [
    {
      match: 'SELECT_HIDDEN',
      when:  [
        {id:     'vorhanden',
          value: 'N'
        },
        {id:     'vorhanden',
          value: 'NV'
        },
        {id:     'typ',
          value: null
        },
        ...documentTypes
          .filter(type => !type.zahlungsempfaengerRequired)
          .map(type => ({
            id:    'typ',
            value: type
          }))
      ]
    }
  ];
  const layout = {
    element: {
      host: 'gsm-flex-fullwidth'
    }
  };

  return [
    {
      id:            'zahlungsempfaenger_instructionText',
      type:          TYPE_INFO,
      content:       'Bitte wählen/erfassen Sie den Zahlungsempfänger.',
      isInstruction: true,
      hidden:        true,
      relations,
      layout,
      additional:    {
        hideLog: true
      }
    },
    {
      id:         'zahlungsempfaenger',
      type:       TYPE_ZAHLUNGSEMPFAENGER,
      hidden:     true,
      kunden,
      relations,
      layout,
      additional: {
        immediateValidation
      }
    }
  ];
}
